enum RouteNameEnum {
    Flight = 'FLIGHT',
    Train = 'TRAIN',
    Transfer = 'TRANSFER',
    Options = 'OPTIONS',
    OptionsV2 = 'OPTIONSV2',
    UserInfo = 'USER_INFO',
    UserInfoV2 = 'USER_INFO_V2',
    Payment = 'PAYMENT',
    PaymentV2 = 'PAYMENTV2',
    Success = 'SUCCESS',
    Paid = 'PAID',
    Error = 'ERROR',
    NewPassword = 'NEW_PASSWORD',
    BalancePayment = 'BALANCE_PAYMENT',
    WidgetCartSuccess = 'WIDGET_CART_SUCCESS'
}

export default RouteNameEnum